// src/features/editor/uploadsApi.ts
import { api } from '@/store/api'

export const uploadsApi = api.injectEndpoints({
  endpoints: (build) => ({
    deleteFile: build.mutation<void, { fileUrl: string }>({
      query: ({ fileUrl }) => ({
        url: `utils/delete-file?file_url=${encodeURIComponent(fileUrl)}`,
        method: 'DELETE',
        meta: { skipErrorToast: true },
      }),
    }),
  }),
})

export const { useDeleteFileMutation } = uploadsApi
